'use client';

import { useQuery } from '@tanstack/react-query';
import { controlsService } from '@/shared/api/services/controls.service';
import { cacheKeys } from '@/shared/lib/cache-invalidation';
import { filterValidControls } from '../lib/control-validation';

/**
 * All sketches (controls) across every angle of a project, newest first.
 * Backs the Brief "Sketches" section. Returns every sketch — including unused
 * drafts not yet attached to a render — filtered only for a valid file URL.
 */
export function useProjectControls(
  projectId: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: cacheKeys.controls.listByProject(projectId),
    queryFn: () => controlsService.getControlsForProject(projectId),
    select: filterValidControls,
    enabled: !!projectId && options?.enabled !== false,
    staleTime: 2 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
